import axios from 'axios'

export default {
    namespaced: true,
    state: {
        childcareApplication: {},
    },
    mutations: {
        SET_CHILDCARE_APPLICATION(state, payload) {
            state.childcareApplication = payload;
        },
    },
    actions: {
        async FetchChildcareApplication({ commit }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/fetch`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            response.data.payload = HydratePayload(response.data.payload);

                            commit('SET_CHILDCARE_APPLICATION', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => reject(`FetchChildcareApplication: ${error.message}`));
            });
        },
        async InsertChildcareApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/insert`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`InsertChildcareApplication: ${error.message}`));
            });
        },
        async UpdateChildcareApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/update`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateChildcareApplication: ${error.message}`));
            });
        },
        async UpdateChildcareApplicationBypassEvidenceFields({ }, obj) {
            obj.BypassEvidenceFields = StringifyJSON(obj.BypassEvidenceFields);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/update/bypass-evidence-fields`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`UpdateChildcareApplicationBypassEvidenceFields: ${error.message}`));
            });
        },
        async UpdateChildcareApplicationLastPageAccessed({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/update/last-page-accessed`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        //else reject(response.data.message);
                    }).catch(error => reject(`UpdateChildcareApplicationLastPageAccessed: ${error.message}`));
            });
        },
        async SubmitChildcareApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/submit`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`SubmitChildcareApplication: ${error.message}`));
            });
        },
        async CancelChildcareApplication({ }, obj) {
            obj.Payload = DehydratePayload(obj.Payload);

            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/cancel`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`CancelChildcareApplication: ${error.message}`));
            });
        },
        async DeleteChildcareApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/applications/childcare/delete`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) resolve(response.data);
                        else reject(response.data.message);
                    }).catch(error => reject(`DeleteChildcareApplication: ${error.message}`));
            });
        },
    },
    getters: {
        ChildcareApplication(state) { return state.childcareApplication; },
    }
};

function HydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = CoalesceJSON(payload.benefitsReceived);
        payload.careExperienceTypes = CoalesceJSON(payload.careExperienceTypes);
        payload.childrenDetails = CoalesceJSON(payload.childrenDetails);
        payload.overrideEvidenceFields = CoalesceJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = CoalesceJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = CoalesceJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function DehydratePayload(payload) {
    if (payload != null) {
        payload.benefitsReceived = StringifyJSON(payload.benefitsReceived);
        payload.careExperienceTypes = StringifyJSON(payload.careExperienceTypes);
        payload.childrenDetails = StringifyJSON(payload.childrenDetails);
        payload.overrideEvidenceFields = StringifyJSON(payload.overrideEvidenceFields);
        payload.requiredEvidenceFields = StringifyJSON(payload.requiredEvidenceFields);
        payload.bypassEvidenceFields = StringifyJSON(payload.bypassEvidenceFields);
    }

    return payload;
}
function StringifyJSON(object) {
    if (object == null) return null;
    else if (typeof object == 'string') return object;
    else return JSON.stringify(object);
};
function CoalesceJSON(object, returnObject) {
    if (object == null || object == '') return returnObject;
    else if (typeof object == 'object') return object;
    else return JSON.parse(object);
};

